import RichText from "./RichText";

// Proyecto destacado. Encabezado tipo experiencia (título + subtítulo, con una
// etiqueta a la derecha), línea de stack técnico en cursiva y bullets.
export default function ProjectItem({ title, subtitle, tag, stack, bullets = [] }) {
  return (
    <article className="cv-exp cv-project">
      <div className="cv-exp-head">
        <p className="cv-exp-heading">
          <span className="cv-company">{title}</span>
          {subtitle ? (
            <>
              <span className="cv-exp-sep"> — </span>
              <span className="cv-exp-role">{subtitle}</span>
            </>
          ) : null}
        </p>
        {tag ? <span className="cv-period">{tag}</span> : null}
      </div>
      {stack ? <p className="cv-project-stack">{stack}</p> : null}
      {bullets.length > 0 && (
        <ul className="cv-bullets">
          {bullets.map((b, i) => (
            <li key={i}>
              <RichText text={b} />
            </li>
          ))}
        </ul>
      )}
    </article>
  );
}
